<!--
科研规模年度统计
-->
<template>
  <div>
    <canvas ref="canvas"></canvas>
    <v-divider/>
    <v-responsive style="height: 80px;">
      <v-container fill-height>
        <v-layout align-center>
          <v-flex text-xs-center>
            <v-list>
              <v-list-tile>
                <v-list-tile-avatar color="orange">
                  <span class="white--text headline">¥</span>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <span>{{currentLabel}}</span>
                    <span class="headline" style="color: #0d47a1">{{currentData}}</span>
                    <span> 万元</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
  </div>
</template>

<script>
  import {Line, mixins} from 'vue-chartjs'

  const uri = '/api/proj/report/contract-by-year';

  export default {
    extends: Line,
    mixins: [mixins.reactiveData],
    data() {
      return {
        chartData: null,
        options: {
          responsive: true,
          title: {
            display: true,
            text: '科研规模年度统计'
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: false,
                labelString: '年度'
              }
            }],
            yAxes: [{
              display: true,
              ticks:{
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '规模（万元）'
              }
            }]
          }
        }
      }
    },
    created() {
      this.axios.get(uri).then(
        rsp => {
          this.chartData = rsp.data;
          this.loading = false;
        }
      )
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
    computed: {
      currentLabel() {
        return this.chartData ? `${this.chartData.labels.slice(-1)[0]}年${this.chartData.datasets[0].label}` : ""
      },
      currentData() {
        return this.chartData ? `${Math.round(this.chartData.datasets[0].data.slice(-1)[0] * 100) / 100 }` : ""
      }
    }
  }
</script>

<style scoped>

</style>
